import {
	createAudience200Schema,
	createAudienceMutationRequestSchema,
	deleteAudience200Schema,
	deleteAudiencePathParamsSchema,
	listAudiences200Schema,
	listAudiencesQueryParamsSchema,
	searchAudience200Schema,
	searchAudienceMutationRequestSchema,
} from "../schemas/audienceApi.schemas";
import type {
	CreateAudienceResponse,
	DeleteAudienceResponse,
	ListAudiencesResponse,
	SearchAudienceResponse,
} from "../types/audienceApi.types";

// API endpoint contracts for audience management
export const audienceEndpointContract = {
	listAudiences: {
		path: "/audiences",
		method: "GET" as const,
		querySchema: listAudiencesQueryParamsSchema,
		responseSchema: listAudiences200Schema,
		responseType: {} as ListAudiencesResponse,
	},
	searchAudience: {
		path: "/audiences/find",
		method: "POST" as const,
		requestSchema: searchAudienceMutationRequestSchema,
		responseSchema: searchAudience200Schema,
		responseType: {} as SearchAudienceResponse,
	},
	createAudience: {
		path: "/audiences",
		method: "POST" as const,
		requestSchema: createAudienceMutationRequestSchema,
		responseSchema: createAudience200Schema,
		responseType: {} as CreateAudienceResponse,
	},
	deleteAudience: {
		path: "/audiences/:audienceGroupId",
		method: "DELETE" as const,
		pathSchema: deleteAudiencePathParamsSchema,
		responseSchema: deleteAudience200Schema,
		responseType: {} as DeleteAudienceResponse,
	},
} as const;
